import {Component} from '@angular/core';

@Component({
  selector: 'app-location-icon',
  templateUrl: './location-icon.component.html'
})
export class LocationIconComponent {
}
